
import { defineComponent, PropType } from 'vue';
import { OdooVehicles } from '@/lib/api/odoo.api';
import { storeToRefs } from 'pinia';
import { useCouponStore } from '@/store/useCoupon';
import { useScannerCouponStore } from '@/store/useScannerCoupon';
import { print } from '@/store/stateless/print';

export default defineComponent({
  props: {
    totalAmount: {
      required: true,
      type: String,
    },
    processedCount: {
      required: true,
      type: Number,
    },
    vehiclePlate: {
      required: true,
      type: Object as PropType<OdooVehicles>,
    },
    driverLicence: {
      required: true,
      type: String,
    },
    batchId: {
      required: true,
      type: String,
    }
  },
  setup() {
    const coupon = useCouponStore();
    const scannerCoupon = useScannerCouponStore();
    const {
      openImport,
      enableClear,
    } = storeToRefs(coupon);
    const { currentScanner } = storeToRefs(scannerCoupon);

    const printReceipt = () => {
      print.receipt('print');
    };

    const closeReport = () => {
      openImport.value = false;
      enableClear.value = true;
    }

    return {
      openImport,
      currentScanner,
      print,
      printReceipt,
      closeReport,
    };
  },
});
